export default "__VITE_ASSET__B94KmLd8__"